/** ponytail: unsigned token; server gate validates sid before SPA load. */

export interface ShareTokenPayload {
  sid: string;
  exp: number;
  cfg?: Record<string, unknown>;
}

function base64UrlDecode(token: string): string {
  const padded = token.replace(/-/g, "+").replace(/_/g, "/");
  const pad = padded.length % 4 === 0 ? "" : "=".repeat(4 - (padded.length % 4));
  return atob(padded + pad);
}

export function decodeShareToken(token: string): ShareTokenPayload | null {
  try {
    const parsed = JSON.parse(base64UrlDecode(token)) as ShareTokenPayload;
    if (typeof parsed.sid !== "string" || typeof parsed.exp !== "number") {
      return null;
    }
    if (!parsed.sid || parsed.sid.length < 16) return null;
    return parsed;
  } catch {
    return null;
  }
}

/** Read share token segment from `/<token>/` path. */
export function readShareTokenFromPath(pathname = window.location.pathname): string | null {
  const segment = pathname.replace(/\/+$/, "").split("/").filter(Boolean)[0];
  if (!segment || segment.length < 20 || !/^[A-Za-z0-9_-]+$/.test(segment)) {
    return null;
  }
  return segment;
}

export function isSharePath(pathname?: string): boolean {
  return readShareTokenFromPath(pathname ?? window.location.pathname) !== null;
}
